module.exports = __webpack_public_path__ + "img/icon_card01.bafff7da.png";